import { ParseNode } from '../../Parse/ParseNode';
import { ExprForm } from '../ExprForm';
import { Access } from './Access';
import { Generic } from './Generic';
export var Bin;
(function (Bin) {
    function matches(root) {
        if (root.type === "CallExpression" &&
            root.callee.toLowerCase() === 'bin' &&
            root.arguments.length === 2 &&
            ParseNode.isAccess(root.arguments[0]) &&
            root.arguments[1].type === "NumberLiteral") {
            return true;
        }
        return false;
    }
    Bin.matches = matches;
    function parse(root) {
        if (matches(root)) {
            const [accessNode, sizeNode] = root.arguments;
            const path = Access.parse(accessNode);
            if (path.form === ExprForm.Access) {
                return Parsed.make(root, path.path, +sizeNode.value);
            }
        }
        return Generic.Parsed.make(root);
    }
    Bin.parse = parse;
    function source(expr, size) {
        return `BIN(${ParseNode.toString(expr.root)}, ${size})`;
    }
    Bin.source = source;
    let Parsed;
    (function (Parsed) {
        function make(root, path, size) {
            const name = `BIN(${path.name}, ${round(size)})`;
            return {
                form: ExprForm.Bin,
                state: "PARSED",
                name,
                root,
                path,
                size,
            };
        }
        Parsed.make = make;
        function round(value) {
            return parseFloat(Math.abs(value) >= 1 ? value.toFixed(2) : value.toPrecision(2));
        }
    })(Parsed = Bin.Parsed || (Bin.Parsed = {}));
    let Compiled;
    (function (Compiled) {
        function make(expr, stage, data) {
            return {
                ...expr,
                state: "COMPILED",
                stage,
                data,
            };
        }
        Compiled.make = make;
    })(Compiled = Bin.Compiled || (Bin.Compiled = {}));
})(Bin || (Bin = {}));
